export type DataRecord = {
  weekStart: Date;
  price: number;
  volume: number;
}

export const data = [
  // weekStart, price, volume
  [1690786800000, 29198.33, 43516370018],
  [1690182000000, 29273.9, 39605076389],
  [1689577200000, 30060.75, 44395847318],
  [1688972400000, 30221.07, 49680696007],
  [1688367600000, 30164.49, 45075677454],
  [1687762800000, 30623.76, 53082215760],
  [1687158000000, 30457.7, 60632937558],
  [1686553200000, 26339.43, 41276733543],
  [1685948400000, 25920.86, 40057040491],
  [1685343600000, 27104.41, 37202558551],
  [1684738800000, 28100.31, 37272906315],
  [1684134000000, 26751.47, 36776706579],
  [1683529200000, 26906.17, 36949699199],
  [1682924400000, 28443.05, 42279940543],
  [1682319600000, 29310.54, 45707612415],
  [1681714800000, 27588.57, 42246891117],
  [1681110000000, 30304.87458, 39235005747],
  [1680505200000, 28321.8616, 32462401269],
  [1679900400000, 28188.1801, 38604497673],
  [1679295600000, 27983.58903, 59761754950],
  [1678690800000, 27911.812, 84925445168],
  [1678089600000, 21952.79781, 45468265068],
  [1677484800000, 22434.9936, 38599272676],
  [1676880000000, 23531.2037, 53396486746],
  [1676275200000, 24332.2815, 69998990619],
  [1675670400000, 21753.75323, 72686632967],
  [1675065600000, 22938.18469, 76316451220],
  [1674460800000, 23775.9829, 75245897355],
  [1673856000000, 22723.9532, 69306158604],
  [1673251200000, 20856.05839, 61607359355],
  [1672646400000, 17070.57451, 31094053572],
  [1672041600000, 16607.06946, 32368138357],
  [1671436800000, 16829.9184, 33003735245],
  [1670832000000, 16750.76581, 40674577445],
  [1670227200000, 17091.91654, 30589177657],
  [1669622400000, 17130.16533, 39254670212],
  [1669017600000, 16432.36462, 47511460133],
  [1668412800000, 16291.4477, 52066060770],
  [1667808000000, 16349.9976, 100243000000],
  [1667199600000, 20913.0539, 74426198199],
  [1666594800000, 20621.7479, 77110206318],
  [1665990000000, 19548.7249, 51121258389],
  [1665385200000, 19259.62065, 56404743252],
  [1664780400000, 19436.3351, 58165526144],
  [1664175600000, 19035.34988, 78302786809],
  [1663570800000, 18814.0516, 75282361184],
  [1662966000000, 19393.59391, 68956498887],
  [1662361200000, 21789.45241, 49910074706],
  [1661756400000, 19975.3081, 52303629551],
  [1661151600000, 19606.7351, 51305006020],
  [1660546800000, 21515.70635, 55548939002],
  [1659942000000, 24323.00217, 66177459376],
  [1659337200000, 23170.70242, 66243157931],
  [1658732400000, 23314.4296, 76053711619],
  [1658127600000, 22600.78471, 82219712351],
  [1657522800000, 20769.40226, 58689727941],
  [1656918000000, 20857.65584, 52440094755],
  [1656313200000, 19310.0755, 43440926558],
  [1655708400000, 21029.2163, 52145170595],
  [1655103600000, 20554.9027, 91153755134],
  [1654498800000, 26704.72936, 57078196873],
  [1653894000000, 29909.21037, 53775979951],
  [1653289200000, 29445.7241, 55851431536],
  [1652684400000, 30366.04222, 57270995980],
  [1652079600000, 31333.76562, 97356477157],
  [1651474800000, 33933.54281, 65085183501],
  [1650870000000, 38467.094, 62279709631],
  [1650265200000, 39479.99697, 64795441798],
  [1649660400000, 39678.0001, 69447732597],
  [1649055600000, 42242.7841, 75068455333],
  [1648450800000, 46430.69671, 67360537115],
  [1647846000000, 46842.71955, 54145787520],
  [1647241200000, 41252.05199, 53913557583],
  [1646640000000, 37824.35153, 71797513557],
  [1646035200000, 38385.18525, 68446796123],
  [1645430400000, 37714.48389, 77634673030],
  [1644825600000, 38464.8528, 52817080033],
  [1644220800000, 42235.5136, 63903799794],
  [1643616000000, 42388.07234, 56296723856],
  [1643011200000, 37937.339, 64122333865],
  [1642406400000, 36231.1426, 71230719020],
  [1641801600000, 43104.67713, 69027321691],
  [1641196800000, 41880.90095, 96418615111],
  [1640592000000, 47313.6322, 77069920814],
  [1639987200000, 50799.97886, 50587709941],
  [1639382400000, 46686.4963, 58480535312],
  [1638777600000, 50116.99176, 119260000000],
  [1638172800000, 49217.9124, 124944000000],
  [1637568000000, 57158.66834, 79527907994],
  [1636963200000, 58681.09231, 85859434281],
  [1636358400000, 65255.04686, 77018443842],
  [1635750000000, 63180.13308, 74132302244],
  [1635145200000, 61339.97564, 95279513547],
  [1634540400000, 60849.6164, 97316346185],
  [1633935600000, 61582.25155, 96998694721],
  [1633330800000, 54689.5713, 75214096623],
  [1632726000000, 48144.1454, 53704404834],
  [1632121200000, 43209.8655, 72684821942],
  [1631516400000, 47201.5018, 61557377134],
  [1630911600000, 46058.0015, 66861684465],
  [1630306800000, 51698.7267, 59833850689],
  [1629702000000, 48876.7643, 59373965416],
  [1629097200000, 49223.94712, 65893934035],
  [1628492400000, 47057.4919, 69752943771],
  [1627887600000, 43780.2388, 65834712983],
  [1627282800000, 40120.70072, 75426954260],
  [1626678000000, 35227.35, 44698866163],
  [1626073200000, 31813, 50811226194],
  [1625468400000, 34249.77404, 60649662983],
  [1624863600000, 35312.38754, 52255781837],
  [1624258800000, 34579.03, 75147782482],
  [1623654000000, 35648.51716, 67245848793],
  [1623049200000, 38990, 63681784760],
  [1622444400000, 35781.01, 67915601949],
  [1621839600000, 35618.15758, 84637466059],
  [1621234800000, 34834.68224, 121466000000],
  [1620630000000, 46395.05, 101828000000],
  [1620025200000, 58169.72762, 95247842835],
  [1619420400000, 56563.76, 84661751088],
  [1618815600000, 48987.68164, 126156000000],
  [1618210800000, 56037.12872, 151835000000],
  [1617606000000, 60018.28649, 99038153700],
  [1617001200000, 58215.19, 100081000000],
  [1616396400000, 55861.95, 100625000000],
  [1615791600000, 57392.2057, 110942000000],
  [1615190400000, 59380.01894, 121014000000],
  [1614585600000, 51409.22675, 108323000000],
  [1613980800000, 44986.74483, 145177000000],
  [1613376000000, 57367.94614, 128571000000],
  [1612771200000, 48673.32971, 137671000000],
  [1612166400000, 38888.63824, 95017112007],
  [1611561600000, 33136.13947, 104369000000],
  [1610956800000, 32261.74435, 96583964272],
  [1610352000000, 35786.41703, 139693000000],
  [1609747200000, 38299.0196, 132950000000],
  [1609142400000, 32877.60728, 84893575760],
  [1608537600000, 26326.48184, 78640878671],
  [1607932800000, 23516.40283, 66037435212],
  [1607328000000, 19169.33845, 40312335698],
  [1606723200000, 19336.69255, 49014608013],
  [1606118400000, 18162.12347, 58301709786],
  [1605513600000, 18413.52697, 49895770987],
  [1604908800000, 15961.34579, 38870195080],
  [1604304000000, 15499.08129, 40498041454],
  [1603695600000, 13735.00686, 31630604404],
  [1603090800000, 13020.81172, 28142018887],
  [1602486000000, 11490.01581, 21910606808],
  [1601881200000, 11376.43511, 20140294066],
  [1601276400000, 10665.69855, 22464044711],
  [1600671600000, 10766.52245, 27226251898],
  [1600066800000, 10914.68741, 33509959544],
  [1599462000000, 10315.66641, 35251308993],
  [1598857200000, 10257.22974, 41457825176],
  [1598252400000, 11697.79437, 29782951022],
  [1597647600000, 11653.40729, 33608530363],
  [1597042800000, 11892.68092, 35545170188],
  [1596438000000, 11648.08317, 33353519603],
  [1595833200000, 11073.60766, 43692049219],
  [1595228400000, 9917.359474, 20084949582],
  [1594623600000, 9207.816996, 14674288808],
  [1594018800000, 9286.726085, 15814299746],
  [1593414000000, 9072.772592, 14775273581],
  [1592809200000, 9118.117533, 18087156684],
  [1592204400000, 9289.8938, 20427017854],
  [1591599600000, 9352.845602, 23064645567],
  [1590994800000, 9742.573822, 27251452691],
  [1590390000000, 9449.860914, 31187905676],
  [1589785200000, 8791.793685, 32196821475],
  [1589180400000, 9667.578397, 40348687717],
  [1588575600000, 8745.152545, 40525313599],
  [1587970800000, 8894.362675, 35725517026],
  [1587366000000, 7665.828318, 27500719706],
  [1586761200000, 7133.148679, 29200263346],
  [1586156400000, 6977.230636, 31385245091],
  [1585551600000, 6789.732165, 29172339910],
  [1584946800000, 5917.297073, 35433864113],
  [1584342000000, 5843.158786, 48113463800],
  [1583737200000, 5381.745247, 38745402887],
  [1583136000000, 8042.736084, 31309023477],
  [1582531200000, 8557.504358, 32690471659],
  [1581926400000, 9923.65932, 35601010883],
  [1581321600000, 9969.23568, 35760918876],
  [1580716800000, 10128.75028, 29130766440],
  [1580112000000, 9339.574889, 26464784241],
  [1579507200000, 8591.002876, 21649457501],
  [1578902400000, 8697.342225, 29115244637],
  [1578297600000, 8164.590608, 25706226612],
  [1577692800000, 7352.362745, 19749294016],
  [1577088000000, 7386.37606, 20412820651],
  [1576483200000, 7482.961456, 18928947461],
  [1575878400000, 7120.922418, 15751874907],
  [1575273600000, 7516.676668, 17448543260],
  [1574668800000, 7417.184162, 22973572125],
  [1574064000000, 6932.313157, 21547471261],
  [1573459200000, 8503.049435, 18966691572],
  [1572854400000, 9043.004449, 21497823133],
  [1572246000000, 9205.743201, 27040458968],
  [1571641200000, 9544.094411, 22666955251],
  [1571036400000, 8202.005473, 14203593557],
  [1570431600000, 8294.599727, 16335591969],
  [1569826800000, 7876.455218, 14302322252],
  [1569222000000, 8068.668738, 17960938020],
  [1568617200000, 10050.18754, 15125733320],
  [1568012400000, 10313.44353, 15602483439],
  [1567407600000, 10410.18764, 17253024949],
  [1566802800000, 9716.72191, 15983299453],
  [1566198000000, 10118.39958, 15629038160],
  [1565593200000, 10331.46711, 17920990964],
  [1564988400000, 11555.7759, 21197861393],
  [1564383600000, 10948.18762, 15147334562],
  [1563778800000, 9545.094701, 16082967533],
  [1563174000000, 10596.3557, 23674665615],
  [1562569200000, 10288.85312, 24245950628],
  [1561964400000, 11441.6227, 24899761945],
  [1561359600000, 10912.25593, 30251388657],
  [1560754800000, 10880.05131, 20429804952],
  [1560150000000, 9025.723642, 16237795482],
  [1559545200000, 7750.808728, 17548307799],
  [1558940400000, 8781.231373, 22153241973],
  [1558335600000, 8736.628564, 18369527374],
  [1557730800000, 8186.662732, 23614488961],
  [1557126000000, 6992.035884, 15018539145],
  [1556521200000, 5779.333069, 13216828842],
  [1555916400000, 5293.938256, 13836681694],
  [1555311600000, 5349.866311, 11417470654],
  [1554706800000, 5187.562408, 12886745901],
  [1554102000000, 5212.309923, 13518016459],
  [1553497200000, 4202.588398, 7831708438],
  [1552892400000, 4024.480056, 6846912976],
  [1552287600000, 4007.16692, 7345431346],
  [1551686400000, 3902.806463, 7215281621],
  [1551081600000, 3881.076222, 6508638463],
  [1550476800000, 3807.506664, 6074763193],
  [1549872000000, 3630.269019, 3674086322],
  [1549267200000, 3663.532767, 3524117948],
  [1548662400000, 3451.480647, 3557348470],
  [1548057600000, 3575.695347, 3635125486],
  [1547452800000, 3583.507436, 4452504988],
  [1546848000000, 3553.227143, 4124379393],
  [1546243200000, 4085.907582, 3805099726],
  [1545638400000, 3863.165984, 4373148346],
  [1545033600000, 3980.147519, 4268215918],
  [1544428800000, 3259.040242, 2773246942],
  [1543824000000, 3586.572261, 3528527548],
  [1543219200000, 4143.979048, 4352931802],
  [1542614400000, 4008.329436, 4308560219],
  [1542009600000, 5647.479577, 3819910810],
  [1541404800000, 6407.676509, 3831913753],
  [1540796400000, 6456.241631, 3282631823],
  [1540191600000, 6406.221101, 3122904169],
  [1539586800000, 6475.861332, 3697566025],
  [1538982000000, 6321.811255, 2979000915],
  [1538377200000, 6595.637642, 2834651197],
  [1537772400000, 6619.480812, 3622373168],
  [1537167600000, 6709.838127, 3611233200],
  [1536562800000, 6512.152478, 3008180532],
  [1535958000000, 6277.682277, 3719632472],
  [1535353200000, 7277.239549, 3744393801],
  [1534748400000, 6705.158423, 3298062096],
  [1534143600000, 6509.311913, 3937786226],
  [1533538800000, 6342.511734, 3891492395],
  [1532934000000, 7041.990104, 4345771646],
  [1532329200000, 8211.614335, 4896096900],
  [1531724400000, 7391.747574, 5000071580],
  [1531119600000, 6346.599551, 4119557016],
  [1530514800000, 6711.7568, 4610080638],
  [1529910000000, 6364.401842, 3694209966],
  [1529305200000, 6149.117943, 3076074996],
  [1528700400000, 6461.213025, 3152417607],
  [1528095600000, 6797.078904, 3372094469],
  [1527490800000, 7684.931799, 3601287889],
  [1526886000000, 7363.93676, 3902517347],
  [1526281200000, 8499.1229, 4629195155],
  [1525676400000, 8699.820503, 5160731105],
  [1525071600000, 9666.853489, 5969239616],
  [1524466800000, 9413.409305, 6818695260],
  [1523862000000, 8787.210206, 5241227020],
  [1523257200000, 8301.987534, 4519404015],
  [1522652400000, 7000.923355, 3828391794],
  [1522047600000, 6830.630577, 3547809213],
  [1521442800000, 8466.556129, 4117640255],
  [1520838000000, 8092.439642, 4693430616],
  [1520236800000, 9570.367448, 4596494700],
  [1519632000000, 11516.38357, 3617642876],
  [1519027200000, 9699.647408, 4456239113],
  [1518422400000, 10576.17556, 4531275378],
  [1517817600000, 8099.307366, 4684631826],
  [1517212800000, 8256.583798, 4659721080],
  [1516608000000, 11865.23189, 8070955468],
  [1516003200000, 11481.02513, 11670862979],
  [1515398400000, 13815.42967, 14260413068],
  [1514793600000, 16515.28737, 14676113849],
  [1514188800000, 14033.56799, 11023277716],
  [1513584000000, 13812.87681, 14276722281],
  [1512979200000, 19156.71037, 11179471382],
  [1512374400000, 15565.86191, 9682205309],
  [1511769600000, 11304.61703, 5902485870],
  [1511164800000, 9359.825974, 3545335454],
  [1510560000000, 8023.985993, 3799233328],
  [1509955200000, 5991.383039, 3283516422],
  [1509346800000, 7392.794234, 2553778752],
  [1508742000000, 6146.589798, 1958852886],
  [1508137200000, 6018.877567, 1909310015],
  [1507532400000, 5671.364512, 1733784683],
  [1506927600000, 4594.791466, 1016287266],
  [1506322800000, 4361.139973, 1245969705],
  [1505718000000, 3689.71, 1367826211],
  [1505113200000, 3583.22, 2170153916],
  [1504508400000, 4122.58, 2241217566],
  [1503903600000, 4581.11, 2128640209],
  [1503298800000, 4379.94, 2271965967],
  [1502694000000, 4108.93, 2696651181],
  [1502089200000, 4062.87, 1740105173],
  [1501484400000, 3218.02, 1078890470],
  [1500879600000, 2752.85, 986672877],
  [1500274800000, 2731.29, 1392678188],
  [1499670000000, 1922.72, 960974856.2],
  [1499065200000, 2517.59, 851409797.2],
  [1498460400000, 2511.31, 1139892061],
  [1497855600000, 2589.86, 1274241889],
  [1497250800000, 2547.97, 1770275697],
  [1496646000000, 2964.08, 1551241740],
  [1496041200000, 2522.07, 1327162424],
  [1495436400000, 2157.05, 1753650661],
  [1494831600000, 2042.66, 875218040.4],
  [1494226800000, 1804.8, 964218806.6],
  [1493622000000, 1596.72, 681703808.8],
  [1493017200000, 1347.91, 338349896],
  [1492412400000, 1206.77, 255333045],
  [1491807600000, 1183.19, 245832562.7],
  [1491202800000, 1188.05, 435889023.8],
  [1490598000000, 1102.04, 341807354.3],
  [1489993200000, 964.909, 354185102.2],
  [1489388400000, 1038.05, 438643864.5],
  [1488787200000, 1221.39, 266983298],
  [1488182400000, 1267.29, 201079698.9],
  [1487577600000, 1165.57, 154868872.3],
  [1486972800000, 1047.73, 101948547.7],
  [1486368000000, 999.095, 167766161.6],
  [1485763200000, 1028.34, 128047854],
  [1485158400000, 919.518, 98911283.93],
  [1484553600000, 923.612, 104754578.4],
  [1483948800000, 821.828, 162393900.6],
  [1483344000000, 909.923, 274671494.8],
  [1482739200000, 997.777, 155058003.3],
  [1482134400000, 896.59, 136776676.6],
  [1481529600000, 790.248, 72113559.83],
  [1480924800000, 769.492, 82163725.05],
  [1480320000000, 773.52, 73765062.58],
  [1479715200000, 731.981, 86927001.9],
  [1479110400000, 730.999, 91494919.31],
  [1478505600000, 702.087, 73346861],
  [1477897200000, 711.752, 99983450.05],
  [1477292400000, 701.86, 84249649.5],
  [1476687600000, 656.902, 58881955.35],
  [1476082800000, 641.404, 62675757.47],
  [1475478000000, 616.607, 49237908.75],
  [1474873200000, 610.934, 49314574.1],
  [1474268400000, 600.859, 55546053.02],
  [1473663600000, 609.907, 64036698.54],
  [1473058800000, 606.529, 72685290.82],
  [1472454000000, 608.481, 95852402.68],
  [1471849200000, 573.897, 64501934.07],
  [1471244400000, 581.417, 52939343.82],
  [1470639600000, 570.389, 71471205.64],
  [1470034800000, 592.632, 143524643.9],
  [1469430000000, 625.039, 104959843.8],
  [1468825200000, 661.208, 79633420.67],
  [1468220400000, 678.84, 92286573.15],
  [1467615600000, 649.727, 143344411.1],
  [1467010800000, 657.342, 125736355.3],
  [1466406000000, 630.061, 198808579.7],
  [1465801200000, 763.383, 230013684],
  [1465196400000, 672.285, 83918627.42],
  [1464591600000, 575.039, 103292547.9],
  [1463986800000, 525.58, 88289680.81],
  [1463382000000, 439.442, 61151469.74],
  [1462777200000, 457.657, 48537232.47],
  [1462172400000, 458.6, 56719332.18],
  [1461567600000, 451.683, 68754173.6],
  [1460962800000, 458.664, 54792992.93],
  [1460358000000, 427.268, 53978642.35],
  [1459753200000, 421.512, 51758650.95],
  [1459148400000, 420.861, 59937727.88],
  [1458543600000, 426.819, 54782786.39],
  [1457938800000, 414.01, 78276103.28],
  [1457337600000, 414.1, 80057058.54],
  [1456732800000, 407.607, 83133750.91],
  [1456128000000, 433.553, 74099107.85],
  [1455523200000, 438.674, 70651840.98],
  [1454918400000, 407.153, 59355037.05],
  [1454313600000, 376.569, 46402764.77],
  [1453708800000, 368.661, 53118987.06],
  [1453104000000, 403.198, 61504521.79],
  [1452499200000, 382.775, 76006339.21],
  [1451894400000, 447.7, 43676806.64],
  [1451289600000, 429.88, 42287236.12],
  [1450684800000, 422.223, 67026621.33],
  [1450080000000, 442.363, 75670945.93],
  [1449475200000, 434.394, 76614391.39],
  [1448870400000, 391.638, 57074182.11],
  [1448265600000, 371.419, 42133119.11],
  [1447660800000, 324.223, 42407873.89],
  [1447056000000, 320.231, 67216540.44],
  [1446451200000, 372.318, 126769999.9],
  [1445842800000, 325.732, 48841618.42],
  [1445238000000, 283.117, 28169033.15],
  [1444633200000, 261.688, 25947643],
  [1444028400000, 247.128, 18392775.54],
  [1443423600000, 238.199, 18753251.47],
  [1442818800000, 232.748, 18255805.83],
  [1442214000000, 231.151, 18073344.39],
  [1441609200000, 230.809, 20392045.49],
  [1441004400000, 239.945, 19884784.2],
  [1440399600000, 228.479, 34853941.15],
  [1439794800000, 228.383, 32186786.8],
  [1439190000000, 258.514, 24245842.78],
  [1438585200000, 265.024, 27741986.08],
  [1437980400000, 282.624, 22770146.05],
  [1437375600000, 292.627, 22038242.59],
  [1436770800000, 273.469, 38833484.39],
  [1436166000000, 311.024, 51110658.25],
  [1435561200000, 271.818, 25929483.72],
  [1434956400000, 248.987, 16025337.08],
  [1434351600000, 243.946, 25804393.15],
  [1433746800000, 233.554, 17419365.76],
  [1433142000000, 223.39, 17744320.05],
  [1432537200000, 229.968, 14668223.79],
  [1431932400000, 240.95, 15980408.8],
  [1431327600000, 236.796, 18466683.99],
  [1430722800000, 240.491, 23118132.41],
  [1430118000000, 240.376, 23959930.06],
  [1429513200000, 219.391, 20023432.72],
  [1428908400000, 222.604, 21340704.13],
  [1428303600000, 236.071, 21881788.45],
  [1427698800000, 260.451, 21391300.41],
  [1427094000000, 242.637, 25130454.37],
  [1426489200000, 267.969, 27587041.22],
  [1425884400000, 285.607, 37160521.97],
  [1425283200000, 274.383, 34550188.19],
  [1424678400000, 260.371, 18522389.14],
  [1424073600000, 236.145, 27823972.17],
  [1423468800000, 233.704, 28571207.82],
  [1422864000000, 223.3, 27823822.83],
  [1422259200000, 226.998, 48406191.05],
  [1421654400000, 253.477, 26324258.77],
  [1421049600000, 210.591, 48123315.42],
  [1420444800000, 267.88, 28658706.26],
  [1419840000000, 264.201, 16693112.41],
  [1419235200000, 317.506, 15940800.08],
  [1418630400000, 320.896, 25106390.59],
  [1418025600000, 351.714, 17933978.51],
  [1417420800000, 375.156, 11389165.36],
  [1416816000000, 378.236, 20318003.08],
  [1416211200000, 367.968, 24713257.27],
  [1415606400000, 388.308, 31522619.7],
  [1415001600000, 363.013, 14994021.36],
  [1414393200000, 325.995, 14806325.92],
  [1413788400000, 354.681, 15594895.67],
  [1413183600000, 390.54, 23710921.18],
  [1412578800000, 379.171, 59349088.27],
  [1411974000000, 321.77, 33122885.86],
  [1411369200000, 377.06, 25825862.95],
  [1410764400000, 398.645, 24628351.81],
  [1410159600000, 477.745, 19129945.15],
  [1409554800000, 482.633, 20839336.21],
  [1408950000000, 477.332, 20481395.03],
  [1408345200000, 508.066, 38467921.09],
  [1407740400000, 492.633, 20674393.17],
  [1407135600000, 591.01, 9715472.4],
  [1406530800000, 585.625, 14644825.83],
  [1405926000000, 594.316, 11361659.88],
  [1405321200000, 623.994, 11695046.39],
  [1404716400000, 626.521, 13094946.2],
  [1404111600000, 635.807, 24986377.89],
  [1403506800000, 602.715, 14349195.29],
  [1402902000000, 602.273, 19908602.33],
  [1402297200000, 592.937, 26895778.52],
  [1401692400000, 656.14, 34491344.55],
  [1401087600000, 630.229, 29176683.85],
  [1400482800000, 571.588, 21221692.53],
  [1399878000000, 446.264, 7550288.863],
  [1399273200000, 438.886, 10456360.69],
  [1398668400000, 436.403, 14654327.75],
  [1398063600000, 436.39, 16531417.24],
  [1397458800000, 498.168, 36239025.38],
  [1396854000000, 414.063, 25738388.99],
  [1396249200000, 460.499, 33736193.01],
  [1395644400000, 460.273, 28166563.3],
  [1395039600000, 561.272, 18452600.07],
  [1394434800000, 631.11, 13546968.85],
  [1393833600000, 636.96, 36211202.61],
  [1393228800000, 559.79, 48449145.13],
  [1392624000000, 605.82, 34557755.92],
  [1392019200000, 616.63, 61568277.05],
  [1391414400000, 682.9, 37129889.67],
  [1390809600000, 825.37, 29381819.53],
  [1390204800000, 885.28, 25067218.48],
  [1389600000000, 870.96, 29836951.27],
  [1388995200000, 863.22, 65675184.93],
  [1388390400000, 933.53, 30303060.64],
  [1387785600000, 745.05, 15245227.74],
  [1387180800000, 617.18, 0],
  [1386576000000, 876.12, 0],
  [1385971200000, 795.87, 0],
  [1385366400000, 955.85, 0],
  [1384761600000, 774.25, 0],
  [1384156800000, 492.11, 0],
  [1383552000000, 326.62, 0],
  [1382943600000, 215.05, 0],
  [1382338800000, 196.44, 0],
  [1381734000000, 174.61, 0],
  [1381129200000, 138.13, 0],
  [1380524400000, 129, 0],
  [1379919600000, 137.34, 0],
  [1379314800000, 129.12, 0],
  [1378710000000, 130.37, 0],
  [1378105200000, 121.66, 0],
  [1377500400000, 138.34, 0],
  [1376895600000, 122.111, 0],
  [1376290800000, 113.5, 0],
  [1375686000000, 105, 0],
  [1375081200000, 105.144, 0],
  [1374476400000, 99.756, 0],
  [1373871600000, 90.7573, 0],
  [1373266800000, 94.6913, 0],
  [1372662000000, 74.5611, 0],
  [1372057200000, 96.614, 0],
  [1371452400000, 107.6, 0],
  [1370847600000, 99.51, 0],
  [1370242800000, 100, 0],
  [1369638000000, 122.292, 0],
  [1369033200000, 133.48, 0],
  [1368428400000, 121.99, 0],
  [1367823600000, 115, 0],
  [1367218800000, 115.91, 0],
  [1366614000000, 134.21, 0],
  [1366009200000, 119.2, 0],
  [1365404400000, 90, 0],
  [1364799600000, 162.301, 0],
  [1364194800000, 93.03, 0],
  [1363590000000, 71.5, 0],
  [1362985200000, 47.4, 0],
  [1362384000000, 46, 0],
  [1361779200000, 34.5, 0],
  [1361174400000, 29.89, 0],
  [1360569600000, 26.8146, 0],
  [1359964800000, 23.9698, 0],
  [1359360000000, 20.59, 0],
  [1358755200000, 17.8182, 0],
  [1358150400000, 15.7, 0],
  [1357545600000, 14.116, 0],
  [1356940800000, 13.454, 0],
  [1356336000000, 13.45, 0],
  [1355731200000, 13.312, 0],
  [1355126400000, 13.3, 0],
  [1354521600000, 13.388, 0],
  [1353916800000, 12.5, 0],
  [1353312000000, 12.4821, 0],
  [1352707200000, 11.6515, 0],
  [1352102400000, 10.8687, 0],
  [1351494000000, 10.8001, 0],
  [1350889200000, 10.7, 0],
  [1350284400000, 11.6311, 0],
  [1349679600000, 11.7389, 0],
  [1349074800000, 11.8, 0],
  [1348470000000, 12.4, 0],
  [1347865200000, 12.1933, 0],
  [1347260400000, 11.87, 0],
  [1346655600000, 11.02, 0],
  [1346050800000, 10.2041, 0],
  [1345446000000, 10.61, 0],
  [1344841200000, 8, 0],
  [1344236400000, 11.624, 0],
  [1343631600000, 10.87, 0],
  [1343026800000, 8.7103, 0],
  [1342422000000, 8.4096, 0],
  [1341817200000, 7.621, 0],
  [1341212400000, 6.799, 0],
  [1340607600000, 6.629, 0],
  [1340002800000, 6.35, 0],
  [1339398000000, 6.1638, 0],
  [1338793200000, 5.4683, 0],
  [1338188400000, 5.2051, 0],
  [1337583600000, 5.139, 0],
  [1336978800000, 5.09, 0],
  [1336374000000, 4.93, 0],
  [1335769200000, 5.0499, 0],
  [1335164400000, 4.9044, 0],
  [1334559600000, 5.2035, 0],
  [1333954800000, 4.9689, 0],
  [1333350000000, 4.7925, 0],
  [1332745200000, 4.827, 0],
  [1332140400000, 4.55, 0],
  [1331535600000, 5.2794, 0],
  [1330934400000, 4.91, 0],
  [1330329600000, 4.82, 0],
  [1329724800000, 4.922, 0],
  [1329120000000, 4.3867, 0],
  [1328515200000, 5.5147, 0],
  [1327910400000, 5.6888, 0],
  [1327305600000, 5.3809, 0],
  [1326700800000, 6.3097, 0],
  [1326096000000, 7.0018, 0],
  [1325491200000, 7.1136, 0],
  [1324886400000, 5.2677, 0],
  [1324281600000, 4.225, 0],
  [1323676800000, 3.193, 0],
  [1323072000000, 3.2511, 0],
  [1322467200000, 2.8281, 0],
  [1321862400000, 2.4799, 0],
  [1321257600000, 2.2, 0],
  [1320652800000, 2.9969, 0],
  [1320044400000, 2.9596, 0],
  [1319439600000, 3.27, 0],
  [1318834800000, 3.17, 0],
  [1318230000000, 3.557, 0],
  [1317625200000, 4.1029, 0],
  [1317020400000, 5.027, 0],
  [1316415600000, 5.33, 0],
  [1315810800000, 5.2, 0],
  [1315206000000, 5.8644, 0],
  [1314601200000, 8.178, 0],
  [1313996400000, 9.0701, 0],
  [1313391600000, 11.3113, 0],
  [1312786800000, 10.7957, 0],
  [1312182000000, 7.9, 0],
  [1311577200000, 13.35, 0],
  [1310972400000, 13.98, 0],
  [1310367600000, 13.16, 0],
  [1309762800000, 14.9, 0],
  [1309158000000, 15.4405, 0],
  [1308553200000, 16.45, 0],
  [1307948400000, 17.51, 0],
  [1307343600000, 18.5464, 0],
  [1306738800000, 16.7, 0],
  [1306134000000, 8.4299, 0],
  [1305529200000, 6.6901, 0],
  [1304924400000, 6.987, 0],
  [1304319600000, 3.8659, 0],
  [1303714800000, 3.0331, 0],
  [1303110000000, 1.6301, 0],
  [1302505200000, 1.1123, 0],
  [1301900400000, 0.7369, 0],
  [1301295600000, 0.779, 0],
  [1300690800000, 0.82, 0],
  [1300086000000, 0.7411, 0],
  [1299484800000, 0.8925, 0],
  [1298880000000, 0.8999, 0],
  [1298275200000, 0.89, 0],
  [1297670400000, 0.85, 0],
  [1297065600000, 1.05, 0],
  [1296460800000, 0.8997, 0],
  [1295856000000, 0.4799, 0],
  [1295251200000, 0.4424, 0],
  [1294646400000, 0.3868, 0],
  [1294041600000, 0.323, 0],
  [1293436800000, 0.3, 0],
  [1292832000000, 0.265, 0],
  [1292227200000, 0.2401, 0],
  [1291622400000, 0.22, 0],
  [1291017600000, 0.19, 0],
  [1290412800000, 0.27, 0],
  [1289808000000, 0.2768, 0],
  [1289203200000, 0.279, 0],
  [1288594800000, 0.34, 0],
  [1287990000000, 0.1925, 0],
  [1287385200000, 0.115, 0],
  [1286780400000, 0.102, 0],
  [1286175600000, 0.0965, 0],
  [1285570800000, 0.0611, 0],
  [1284966000000, 0.062, 0],
  [1284361200000, 0.0627, 0],
  [1283756400000, 0.0615, 0],
  [1283151600000, 0.0616, 0],
  [1282546800000, 0.064, 0],
  [1281942000000, 0.066, 0],
  [1281337200000, 0.0653, 0],
  [1280732400000, 0.0609, 0],
  [1280127600000, 0.0611, 0],
  [1279522800000, 0.0505, 0],
  [1279350000000, 0.0858, 0],
]
  .sort((a, b) => a[0] - b[0])
  .map((d) => ({
    weekStart: new Date(d[0]),
    price: d[1],
    volume: d[2],
  }))


